import { useEffect, useRef } from 'react';
import { supabase } from '../config/supabase';
import type { RealtimePostgresChangesPayload } from '@supabase/supabase-js';

export interface RealtimeSubscription {
  event?: 'INSERT' | 'UPDATE' | 'DELETE' | '*';
  schema?: string;
  table: string;
  filter?: string;
  callback: (payload: RealtimePostgresChangesPayload<{ [key: string]: unknown }>) => void;
}

export function useRealtimeChannel(
  channelName: string,
  subscriptions: RealtimeSubscription[],
  deps: unknown[] = []
): void {
  const subsRef = useRef(subscriptions);
  subsRef.current = subscriptions;

  useEffect(() => {
    let channel = supabase.channel(channelName);

    for (const sub of subsRef.current) {
      channel = channel.on(
        'postgres_changes',
        {
          event: sub.event ?? '*',
          schema: sub.schema ?? 'public',
          table: sub.table,
          filter: sub.filter,
        },
        sub.callback
      );
    }

    channel.subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelName, ...deps]);
}
